import { lazy, Suspense } from 'react'

import { LoadingTurbo } from 'atoms'

import { PremioPlusScreenComponent } from './PremioPlusScreen.types'
import { usePremioPlusScreen } from './usePremioPlusScreen'

const PremioPlusScreenDesktop = lazy(() => import('./PremioPlusScreen.desktop'))

const PremioPlusScreenMobile = lazy(() => import('./PremioPlusScreen.mobile'))

export const PremioPlusScreen: PremioPlusScreenComponent = () => {
  const props = usePremioPlusScreen()

  const Screen = props.isMobile ? PremioPlusScreenMobile : PremioPlusScreenDesktop

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Screen {...props} />
    </Suspense>
  )
}
